import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogMoreReplyCount from './VeltCommentDialogMoreReplyCount/VeltCommentDialogMoreReplyCount';
import VeltCommentDialogMoreReplyText from './VeltCommentDialogMoreReplyText/VeltCommentDialogMoreReplyText';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltCommentDialogMoreReply = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-more-reply-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogMoreReply.Count = VeltCommentDialogMoreReplyCount;
VeltCommentDialogMoreReply.Text = VeltCommentDialogMoreReplyText;
export default VeltCommentDialogMoreReply;
